import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { erroToastify } from '../../../shared/validacaoToastify';
import { CamposPadroes } from '../../../shared/CamposPadroes';
import { ToastContainer } from "react-toastify";
import { Form, FloatingLabel, Col, InputGroup, OverlayTrigger, Tooltip, Spinner } from 'react-bootstrap';
import { getTodosModelos } from '../../../services/apiModelo';
import { getTodasCondicoes } from '../../../services/apiCondicao';
import { getCategoria, getTodasCategorias } from '../../../services/apiCategoria';
import { getTodasCidades } from '../../../services/apiCidade';
import { getAnuncio, putAnuncio } from '../../../services/apiAnuncio';
import { getImagensAnuncio, putImagem, postImagem, putImagemCapa } from '../../../services/apiImagem';
import imagemPadrao from '../../../components/layout/rodape/M.svg'
import ModalVisualizacaoImg from '../../../components/modal/modalVisualizacaoImg/modalVisualizacaoImg';
import "react-toastify/dist/ReactToastify.css";
import "./alterarAnuncio.css"
import PrimeiroFormulario from '../../../components/formularioAnuncio/primeiroFormulario';
import SegundoFormulario from '../../../components/formularioAnuncio/segundoFormulario';
import TerceiroFormulario from '../../../components/formularioAnuncio/terceiroFomulario';
import QuartoFormulario from '../../../components/formularioAnuncio/quartoFormulario';
import { useAuth } from '../../../context/AuthContext';

function AlterarAnuncio() {
  const { cdAnuncio } = useParams<{ cdAnuncio?: string }>();
  const [categorias, setCategorias] = useState<{ cdCategoria: number; nmCategoria: string; }[]>([]);
  const [modelos, setModelos] = useState<{ cdModelo: number; nmModelo: string; }[]>([]);
  const [cidades, setCidades] = useState<{ cdCidade: number; nmCidade: string; }[]>([]);
  const [condicoes, setCondicoes] = useState<{ cdCondicao: number; nmCondicao: string; }[]>([]);
  const [validacaoAtiva, setValidacaoAtiva] = useState<any>(false);
  const [imagens, setImagens] = useState<File[]>([]);
  const [todasAsImagens, setTodasAsImagens] = useState<any[]>([])
  const [banco, setBanco] = useState<any[]>([])
  const [cdImagens, setCdImagens] = useState<number[]>([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [numeroImagensSelecionadas, setNumeroImagensSelecionadas] = useState<number>(todasAsImagens.length);
  const [cdImagemExcluida, setImagemExcluida] = useState<number[]>([]);
  const [nomeImagemString, setNomeImagemString] = useState<any[]>([]);
  const [cdImagensClonadas, setCdImagensClonadas] = useState<number[]>([]);
  const [todasAsImagensComOuSemId, seTodasAsImagensComOuSemId] = useState<any[]>([]);
  const [originalDataPublicacao, setOriginalDataPublicacao] = useState<string>('');
  const [DataAnteriorPublicacao, setDataAnteriorPublicacao] = useState<string>('');
  const [anuncioAtivo, setAnuncioAtivo] = useState<{ dmAtivo?: boolean; dtPublicacao?: string }>({});
  const userStorage = localStorage.getItem('cdUsuario');
  const cdUsuario = userStorage ? parseInt(userStorage, 10) : 0;
  const [loading, setLoading] = useState(false);
  const [ImagensComId, setImagensComId] = useState<any[]>([]);
  const navigate = useNavigate();
  const { previousRoute } = useAuth();

  const [formValues, setFormValues] = useState({
    cdAnuncio: '',
    nmAnuncio: '',
    cdCategoria: '',
    cdModelo: '',
    cdCondicao: '',
    cdUsuario: 1,
    dtPublicacao: new Date().toLocaleDateString('en-CA'),
    vlAnuncio: '',
    cdCidade: '',
    dmTipoAnuncio: true,
    dmAtivo: true,
    nrAnunciada: '',
    dsAnuncio: '',
    dtInclusao: '',
    dtAlteracao: ''
  });

  useEffect(() => {
    const fetchAnuncio = async () => {
      try {
        if (cdAnuncio) {
          const anuncio = await getAnuncio(cdAnuncio);
          setFormValues({
            cdAnuncio: cdAnuncio,
            nmAnuncio: anuncio.nmAnuncio || '',
            cdCategoria: anuncio.cdCategoria || '',
            cdModelo: anuncio.cdModelo || '',
            cdCondicao: anuncio.cdCondicao || '',
            cdUsuario: anuncio.cdUsuario,
            dtPublicacao: anuncio.dtPublicacao.split('T')[0] || new Date().toISOString().split('T')[0],
            vlAnuncio: anuncio.vlAnuncio || '',
            cdCidade: anuncio.cdCidade || '',
            dmTipoAnuncio: anuncio.dmTipoAnuncio,
            dmAtivo: anuncio.dmAtivo,
            nrAnunciada: anuncio.nrAnunciada || '',
            dsAnuncio: anuncio.dsAnuncio || '',
            dtInclusao: anuncio.dtInclusao || '',
            dtAlteracao: anuncio.dtAlteracao || '',
          });

          setAnuncioAtivo({ dmAtivo: anuncio.dmAtivo, dtPublicacao: anuncio.dtPublicacao.split('T')[0] || new Date().toISOString().split('T')[0] })
          setDataAnteriorPublicacao(formValues.dtPublicacao)

          const imagensAnuncio = await getImagensAnuncio(cdAnuncio);
          const imagensStrings = imagensAnuncio.map((imagem: any) => ({
            imagemString: `data:image/${imagem.nmTipoArquivo};base64,${imagem.mdArquivo}`,
            nmTipoArquivo: imagem.nmTipoArquivo,
            dsArquivoImagem: imagem.dsArquivoImagem,
            cdImagem: imagem.cdImagem
          }));

          setImagensComId(imagensAnuncio.map((imagem: any) => ({
            imagemString: `data:image/${imagem.nmTipoArquivo};base64,${imagem.mdArquivo}`,
            nmTipoArquivo: imagem.nmTipoArquivo,
            dsArquivoImagem: imagem.dsArquivoImagem,
            cdImagem: imagem.cdImagem
          })))

          const idImagem = imagensStrings.map((imagem: any) => imagem.cdImagem);
          setCdImagensClonadas([...idImagem])
          setCdImagens(idImagem);

          const dsArquivoImagem = imagensStrings.map((imagem: any) => imagem.dsArquivoImagem);
          setNomeImagemString(dsArquivoImagem)

          const imagensDoBanco = imagensStrings.map((imagem: any) => ({
            cdImagem: imagem.cdImagem,
            imagemString: imagem.imagemString,
          }));

          setBanco(imagensDoBanco)

          const todasAsImagensCompletas = [...imagensDoBanco.map((im: any) => im.imagemString), ...imagens];
          const todasAsImagensComSemId = todasAsImagensCompletas.map((imagem: string) => {
            const imagemBanco = imagensDoBanco.find((im: any) => im.imagemString === imagem);
            return {
              cdImagem: imagemBanco ? imagemBanco.cdImagem : 0,
              imagemString: imagem,
            };
          });

          seTodasAsImagensComOuSemId(todasAsImagensComSemId);
          setTodasAsImagens(todasAsImagensCompletas);
          setNumeroImagensSelecionadas(todasAsImagensCompletas.length);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchAnuncio();
  }, [cdAnuncio]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseModelos = await getTodosModelos();
        setModelos(responseModelos);

        const responseCidades = await getTodasCidades();
        setCidades(responseCidades);

        const responseCondicoes = await getTodasCondicoes();
        setCondicoes(responseCondicoes);

        const responseCategoria = await getTodasCategorias();
        setCategorias(responseCategoria);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, []);

  const handleFieldChange = (name: string, value: string | number | boolean) => {
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      [name]: value
    }));
    setValidacaoAtiva(false);
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      const imagesArray = Array.from(files);
      setTodasAsImagens((prevTodasAsImagens) => {
        const newTodasAsImagens = [...prevTodasAsImagens, ...imagesArray].slice(0, 5);
        setNumeroImagensSelecionadas(newTodasAsImagens.length);
        return newTodasAsImagens;
      });

      e.target.value = '';
      setValidacaoAtiva(false);
    }
  };

  const handleRemoveImage = (index: number) => {
    setTodasAsImagens((prevTodasAsImagens) => {
      const newTodasAsImagens = [...prevTodasAsImagens];
      const imagem = newTodasAsImagens[index];

      if (typeof imagem === 'string') {
        const codigo = cdImagens[index];
        setImagemExcluida((prev) => {
          const newCdImagemExcluida = [...prev];
          if (!newCdImagemExcluida.includes(codigo)) {
            newCdImagemExcluida.push(codigo);
          }
          return newCdImagemExcluida;
        });
      }

      newTodasAsImagens.splice(index, 1);
      setNumeroImagensSelecionadas(newTodasAsImagens.length);
      return newTodasAsImagens;
    });

    setCdImagens((prevCdImagens) => {
      const newCdImagens = [...prevCdImagens];
      newCdImagens.splice(index, 1);
      return newCdImagens;
    });
  };

  const openModal = (index: number) => {
    setSelectedImageIndex(index);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const handleImageClick = (index: number) => {
    if (todasAsImagens[index]) {
      openModal(index);
    }
  };

  const getImagemUrl = (index: number) => {
    const imagem = todasAsImagens[index];
    if (typeof imagem === 'string') {
      return imagem;
    } else if (imagem instanceof File) {
      return URL.createObjectURL(imagem);
    }
    return '';
  };

  const enviarImagens = async (cdUsuarioInc: number, cdUsuarioAlt: number) => {
    try {
      if (cdImagemExcluida.length > 0) {
        for (let i = 0; i < cdImagemExcluida.length; i++) {
          const cdImagem = cdImagemExcluida[i];
          const imagemPresente = cdImagensClonadas.includes(cdImagem);

          if (imagemPresente) {
            const imagemIndex = cdImagensClonadas.indexOf(cdImagem);
            const imagem = banco[imagemIndex];
            const nomeImagem = nomeImagemString[imagemIndex];

            if (typeof imagem.imagemString === 'string') {
              const formData = new FormData();
              const match = imagem.imagemString.match(/^data:image\/([.\w]+);base64,/);
              if (!match || match.length < 2) {
                console.error('Erro ao extrair tipo de arquivo da imagem base64:', imagem);
                continue;
              }

              let tipoArquivo = match[1];
              const nomeArquivo = nomeImagem;

              const blob = await fetch(imagem.imagemString).then(response => response.blob());
              const file = new File([blob], nomeArquivo, { type: `image/${tipoArquivo}` });
              formData.append("file", file);

              await putImagem(
                cdImagem,
                cdAnuncio ? parseInt(cdAnuncio) : 0,
                cdUsuarioAlt,
                cdUsuarioInc,
                false,
                formData
              );
            }
          }
        }
      }

      const novasImagens = todasAsImagens.filter(imagem => imagem instanceof File);

      for (let i = 0; i < novasImagens.length; i++) {
        const formData = new FormData();
        formData.append("file", novasImagens[i]);

        if (novasImagens[i] instanceof File) {

          await postImagem(
            cdAnuncio ? parseInt(cdAnuncio) : 0,
            cdUsuarioAlt,
            cdUsuarioInc,
            formData
          );
        }
      }
    } catch (error: any) {
      if (error.response && error.response.data) {
        erroToastify(error.response.data);
      } else {
        console.error("Erro ao enviar imagens:", error);
      }
    }
  };

  const atualizarCapa = async () => {
    try {
      const imagensAnuncio = await getImagensAnuncio(cdAnuncio);
      if (!imagensAnuncio || imagensAnuncio.length === 0) {  
        return; 
      }
      for (let i = 0; i < imagensAnuncio.length; i++) {
        let imagem = imagensAnuncio[i];
       
        if (i === 0) {
          const dados = {
            cdImagem: imagem.cdImagem,
            dmCapa: true,
          }
          try {
            await putImagemCapa(dados);
          } catch (error) {
            console.error("Erro ao atualizar capa:", error);
          }
        }
      }
    } catch (error) {
      console.error("Erro ao obter imagens do anúncio:", error);
    }
  }
  
  const handleConfirmar = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    try {
      if (todasAsImagens.length > 0) {
        const imagensSaoValidas = todasAsImagens.every(file => {
          if (file instanceof File) {
            return file.type.startsWith('image/') && !file.type.toLowerCase().includes('svg');
          }
          return true;
        });

        if (!imagensSaoValidas) {
          throw new Error('Por favor, selecione apenas arquivos de imagem.');
        }
      }

      const dataPresente = new Date();
      const dataPublicacaoInput = formValues.dtPublicacao;
      const horaAtual = dataPresente.toTimeString().split(' ')[0];
      const dataAlteracao = `${new Date().toLocaleDateString('en-CA')}T${horaAtual}`;

      let dataPublicacao = '';
      if (formValues.dtPublicacao === originalDataPublicacao.split('T')[0]) {
        dataPublicacao = originalDataPublicacao;
      } else {
        dataPublicacao = `${dataPublicacaoInput}T${horaAtual}`;
      }

      let envioDeDados: any = {
        cdAnuncio: cdAnuncio,
        nmAnuncio: formValues.nmAnuncio === '' ? '' : formValues.nmAnuncio,
        cdUsuario: formValues.cdUsuario,
        dtPublicacao: dataPublicacao,
        vlAnuncio: formValues.vlAnuncio === '' ? null : formValues.vlAnuncio,
        cdCidade: formValues.cdCidade === '' ? null : formValues.cdCidade,
        dmTipoAnuncio: formValues.dmTipoAnuncio,
        dmAtivo: formValues.dmAtivo,
        dsAnuncio: formValues.dsAnuncio === '' ? '' : formValues.dsAnuncio,
        ...CamposPadroes.toObjeto(cdUsuario, cdUsuario, formValues.dtInclusao, dataAlteracao, true)
      };

      if (new Date(dataPublicacao) > dataPresente) {
        envioDeDados.dmAtivo = false;
      }

      if (formValues.dmTipoAnuncio) {
        envioDeDados = {
          ...envioDeDados,
          cdCategoria: formValues.cdCategoria === '' ? null : formValues.cdCategoria,
          cdModelo: formValues.cdModelo === '' ? 0 : formValues.cdModelo,
          cdCondicao: formValues.cdCondicao === '' ? 0 : formValues.cdCondicao,
          nrAnunciada: formValues.nrAnunciada === '' ? 0 : formValues.nrAnunciada,
        };
      }

      const response = await putAnuncio(envioDeDados);
      await enviarImagens(cdUsuario, cdUsuario);
      await atualizarCapa();
  
      const successMessage = "O Anúncio foi alterado com sucesso!";
      if (previousRoute) {
        navigate(`${previousRoute}?successMessage=${encodeURIComponent(successMessage)}`);
      }

    } catch (error: any) {
      if (error.response?.data) {
        erroToastify(error.response.data);
        setValidacaoAtiva(true);
      } else {
        erroToastify(error.message);
        setValidacaoAtiva(true);
      }
    }
    finally {
      setLoading(false);
    }
  };

  const idPaginaAnuncio = 'alterarAnuncio';

  return (
    <>{loading && (
      <div className="spinner-overlay">
        <Spinner animation="border" variant="dark" />
      </div>
    )}
      <form className="container containerAnuncio" onSubmit={handleConfirmar} encType="multipart/form-data" id={idPaginaAnuncio}>
        <PrimeiroFormulario
          formValues={formValues}
          handleFieldChange={handleFieldChange}
          idPagina={idPaginaAnuncio}
        />
        <div className="bloco01">

          <SegundoFormulario
            formValues={formValues}
            handleFieldChange={handleFieldChange}
            validacaoAtiva={validacaoAtiva}
            cidades={cidades}
            anuncio={anuncioAtivo}
            idPagina={idPaginaAnuncio}
          />

          <TerceiroFormulario
            formValues={formValues}
            handleFieldChange={handleFieldChange}
            validacaoAtiva={validacaoAtiva}
            categorias={categorias}
            modelos={modelos}
            condicoes={condicoes}
          />
        </div>
        <div className='bloco02 estiloGeral mt-3 shadow-sm p-3 bg-light rounded'>
          <QuartoFormulario
            formValues={formValues}
            handleFieldChange={handleFieldChange}
            validacaoAtiva={validacaoAtiva}
            todasAsImagens={todasAsImagens}
            setNumeroImagensSelecionadas={setNumeroImagensSelecionadas}
            numeroImagensSelecionadas={numeroImagensSelecionadas}
            imagemPadrao={imagemPadrao}
            handleImageChange={handleImageChange}
            handleRemoveImage={handleRemoveImage}
            handleImageClick={handleImageClick}
            setTodasAsImagens={setTodasAsImagens}
          />
        </div>
        <div className="botoes mt-3">
          <a className="btn btn-outline-danger me-2 btn-sm" href="/milshop/usuario/meus-anuncios" role="button" style={{ width: "100px" }}>Cancelar</a>
          <button type="submit" className="btn btn-outline-primary btn-sm" style={{ width: "100px" }}>Alterar</button>
        </div>
      </form>
      <ModalVisualizacaoImg
        imagens={imagens}
        getImagemUrl={getImagemUrl}
        selectedImageIndex={selectedImageIndex}
        modalIsOpen={modalIsOpen}
        closeModal={closeModal}
      />
      <ToastContainer />
    </>
  );
}
export default AlterarAnuncio;

